  <template>
    <v-navigation-drawer
    v-model="show"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    right
    >
        <v-list
        subheader
        flat
        >
        <v-subheader>Search by Name</v-subheader>
            <v-list-item>
                <v-list-item-content class="pa-0">
                    <v-text-field
                        v-model="keyword"
                        light
                        label="Type Name"
                        @keyup.enter.native="submitSearch"
                        clearable
                        hide-details
                        >
 
                    </v-text-field>               
                    <v-btn
                        depressed 
                        tile
                        color="primary"
                        class="mx-0 mb-0 mt-2"
                        @click.prevent="submitSearch">
                    
                        <v-icon>mdi-magnify</v-icon>
                        Search
                    </v-btn>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
  props: ['show', 'filter'],
  data: () => ({
    keyword: "",
    menu: false,
  }),
  computed: {
  },
  created() {
      this.keyword = this.filter.keyword
  },
  watch: {
    show(newVal) { // watch it
        this.$emit('update-drawer', newVal)
    },
    keyword(newVal) {
        this.$emit('update-keyword', newVal)
    },
  },
  methods: {
    submitSearch() {
        this.$emit('submit-search')
    },
    rangeCancel() {
        this.menu = false
        this.dates = []
    }
  }
}
</script>